import { render, staticRenderFns } from "./InputConfirm.vue?vue&type=template&id=47f21286&"
import script from "./InputConfirm.vue?vue&type=script&lang=js&"
export * from "./InputConfirm.vue?vue&type=script&lang=js&"
import style0 from "./InputConfirm.vue?vue&type=style&index=0&id=47f21286&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports